<template>
<div class="chapter">
<div class="inner_page">
<p><a id="epi"></a></p>
<div class="epiv">Every man’s work shall be made manifest: for the day shall declare it, because it shall be revealed by fire; and the fire shall try every man’s work of what sort it is.</div>
<div class="eps">—I Corinthians 3:13</div>
<div class="epiv"><div> <br/></div>You can’t eat for eight hours a day nor drink for eight hours a day nor make love for eight hours a day—all you can do for eight hours is work. Which is the reason why man makes himself and everybody else so miserable and unhappy.</div>
<div class="eps">—William Faulkner</div>
<div class="epiv"><div> <br/></div>The “work ethic” holds that labor is good in itself; that a man or woman becomes a better person by virtue of the act of working. America’s competitive spirit, the “work ethic” of this people, is alive and well on Labor Day, 1971.</div>
<div class="eps">—Richard M. Nixon</div>
<div class="epiv"><div> <br/></div>I like my job and am good at it, but it sure grinds me down sometimes, and the last thing I need to take home is a headache.</div>
<div class="eps">—TV commercial for Anacin</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587664_oeb_epi_r1.vue?00ebc394